import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// Sanitize a string for use in a filename (strip characters that break on Windows/Mac).
function safeFileSegment(s) {
  return (s || '').toString().trim().replace(/[\\/:*?"<>|]/g, '').replace(/\s+/g, ' ');
}

/**
 * Renders a DOM node to a PDF and triggers a browser download.
 * @param {HTMLElement} node - the element to render (the printable card, not the whole page)
 * @param {string} filename - e.g. "TLS-26-0024 - SANDUSHI" (".pdf" appended automatically)
 */
export async function downloadElementAsPdf(node, filename) {
  if (!node) throw new Error('Nothing to export — print area not found.');

  const canvas = await html2canvas(node, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
  });

  const imgData = canvas.toDataURL('image/png');
  const pageWidthMm = 210; // A4 portrait
  const pageHeightMm = 297;
  const imgWidthMm = pageWidthMm;
  const imgHeightMm = (canvas.height * imgWidthMm) / canvas.width;

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

  if (imgHeightMm <= pageHeightMm) {
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidthMm, imgHeightMm);
  } else {
    // Content taller than one page — slice it across multiple pages
    let heightLeftMm = imgHeightMm;
    let positionMm = 0;
    pdf.addImage(imgData, 'PNG', 0, positionMm, imgWidthMm, imgHeightMm);
    heightLeftMm -= pageHeightMm;
    while (heightLeftMm > 0) {
      positionMm = heightLeftMm - imgHeightMm;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, positionMm, imgWidthMm, imgHeightMm);
      heightLeftMm -= pageHeightMm;
    }
  }

  pdf.save(`${safeFileSegment(filename)}.pdf`);
}
